<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-sitemap"
          inline
          class="px-5 py-4 ml-0"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Áreas
            </div>
          </template>

          <v-btn
            id="btn-nova-area"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float:left"
            relative
            text
            medium
            @click="$router.push('/administracao/areas/add')"
          >
            <v-icon left size="30px">
              mdi-plus-circle
            </v-icon>
            Nova Área
          </v-btn>

          <v-text-field
            id="areas-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mt-4 break-search bs-areas"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="areas-table"
            :headers="headers"
            :items="areas"
            :search.sync="search"
            :headerProps="{
              sortByText: 'Ordenar Por',
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página',
            }"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            :mobile-breakpoint="800"
            no-data-text="Nenhuma Área encontrada"
            no-results-text="Nenhuma Área correspondente encontrada"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id | addLeadingZero }}
            </template>
            <template v-slot:[`item.descricao`]="{ item }">
              {{ item.descricao || '-' }}
            </template>
            <template v-slot:[`item.tipos_servicos`]="{ item }">
              <a
                href="javascript:void(0)"
                @click.stop="openTiposServicosDialog(item.tipos_servicos)"
              >
                {{ item.tipos_servicos.length | addLeadingZero }}
              </a>
            </template>
            <template v-slot:[`item.created_by`]="{ item }">
              {{ item.user ? item.user.name : "Sistema" }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | parseToDateTimeBR }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="edit-areas"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                @click="
                  $router.push(`/administracao/areas/edit/${item.id}`)
                "
              >
                <v-icon small>
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
              <v-btn
                v-if="item.nome !== 'Área Central'"
                id="delete-areas"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                @click="openDialogDelete(item)"
              >
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="tiposServicosDialog" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">Tipos de Serviços</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            dense
            :headers="[
              { text: 'Código', value: 'codigo' },
              { text: 'Nome', value: 'nome' },
              { text: 'Categoria', value: 'categoria' },
            ]"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [10, 50, 100, 300, -1],
              itemsPerPage: -1,
            }"
            :items-per-page="-1"
            :items="tiposServicosDialogData"
            class="elevation-1"
            no-data-text="Nenhum tipo de serviço listado"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="tiposServicosDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-delete
      :dialog.sync="dialogDelete"
      @submitTriggered="deleteArea(dialogDeleteData.id)"
    >
      <template slot="title">
        Deletar Área #{{ dialogDeleteData.id }}
      </template>
      <template slot="body">
        Tem certeza que deseja deletar a área 
        <strong>{{ dialogDeleteData.nome }}</strong
        >?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import tourMixins from "@/mixins/tourMixins";
  import AreasService from "@/services/AreasService";

  export default {
    name: "AreasIndex",
    mixins: [tourMixins],
    components: {
      DialogDelete: () => import("@/components/general/DialogDelete"),
    },
    data() {
      return {
        headers: [
          {
            text: "#",
            value: "id",
          },
          {
            text: "Nome",
            value: "nome",
          },
          {
            text: "Descrição",
            value: "descricao",
          },
          {
            text: "Tipos de Serviços",
            value: "tipos_servicos",
          },
          {
            text: "Criado por",
            value: "created_by",
          },
          {
            text: "Modificado em",
            value: "updated_at",
          },
          {
            sortable: false,
            text: "Ações",
            value: "actions",
            class: "pl-4",
          },
        ],
        areas: [],
        search: "",
        loading: false,
        arrTour: [
          {
            element: "#btn-nova-area",
            intro:
              "Clicando neste botão você poderá cadastrar novas Áreas.",
            scrollTo: "tooltip",
            position: "right",
          },
          {
            element: "#areas-search",
            intro:
              "Neste campo você poderá pesquisar por Áreas já cadastradas.",
            scrollTo: "tooltip",
            position: "bottom",
          },
        ],
        tiposServicosDialog: false,
        tiposServicosDialogData: [],
        dialogDelete: false,
        dialogDeleteData: {
          id: undefined,
          nome: undefined,
        },
      };
    },
    computed: {
      //
    },
    mounted() {
      this.getAreas();
    },
    methods: {
      getAreas() {
        if (!this.$store.getters.getCompanyId) {
          this.$toast.info(
            "Selecione uma empresa para listar as áreas.",
            "",
            { position: "topRight" }
          );
        }

        this.loading = true;
        this.areas = [];

        AreasService.getAll()
          .then((data) => {
            this.areas = data;
          })
          .catch((err) => {
            this.$toast.error("Erro ao recuperar Áreas.", "", {
              position: "topRight",
            });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      openDialogDelete(item) {
        this.dialogDeleteData = {
          id: item.id,
          nome: item.nome,
        };
        this.dialogDelete = true;
      },
      deleteArea(id) {
        this.dialogDelete = false;
        this.dialogDeleteData = {
          id: undefined,
          nome: undefined,
        };

        return AreasService.delete(id)
          .then(() => {
            this.$toast.success("Área excluída com sucesso.", "", {
              position: "topRight",
            });
            this.getAreas();
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao excluir Área.", "", {
              position: "topRight",
            });
          });
      },
      openTiposServicosDialog(tiposServicos) {
        this.tiposServicosDialogData = tiposServicos.map(tipo => ({
          codigo: tipo.codigo,
          nome: tipo.servico,
          categoria: tipo.categorias && tipo.categorias.length > 0 ? tipo.categorias[0].nome : '-'
        }));
        this.tiposServicosDialog = true;
      },
      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.areas.length
          ? this.arrTour
          : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      },
    },
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .areas-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .areas-table table tr td:nth-child(8) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-areas {
      width: 235.86px !important;
    }
  }
</style>
